import {type ReactNode} from 'react';

import {Box, Typography} from '@mui/material';

import {orangeColors} from '../../../../../layouts/theme/designSystem';
import {clampRoundedPercentage} from '../../../../../utils/clampPercentage';

export interface Props {
  title: ReactNode;
  description?: ReactNode;
  score: number;
  color: string;
  barHeight?: number;
  borderedTop?: boolean;
  footer?: ReactNode;
}

export const WorkforceCultureFitPercentRow = ({
  title,
  description,
  score,
  color,
  barHeight = 6,
  borderedTop = false,
  footer,
}: Props) => {
  const percent = clampRoundedPercentage(score);

  return (
    <Box
      sx={{
        ...(borderedTop && {
          pt: 0.25,
          mt: 0.25,
          borderTop: `0.5px solid ${orangeColors[3]}`,
        }),
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
          mb: 0.75,
          ...(borderedTop && {mt: 1.5}),
        }}
      >
        <Box>
          <Typography component='span' sx={{fontSize: 13, fontWeight: 500, color: 'text.primary'}}>
            {title}
          </Typography>
          {description && (
            <Typography
              component='span'
              sx={{fontSize: 12, color: 'text.secondary', ml: 1}}
            >
              {description}
            </Typography>
          )}
        </Box>
        <Typography sx={{fontSize: 13, fontWeight: 500, color, minWidth: 36, textAlign: 'right'}}>
          {percent}%
        </Typography>
      </Box>
      <Box
        sx={{
          height: barHeight,
          bgcolor: orangeColors[5],
          borderRadius: barHeight > 6 ? '4px' : '3px',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            height: '100%',
            width: `${percent}%`,
            borderRadius: barHeight > 6 ? '4px' : '3px',
            bgcolor: color,
            transition: 'width 0.7s cubic-bezier(.4,0,.2,1)',
          }}
        />
      </Box>
      {footer}
    </Box>
  );
};
